import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { AccountPermissionQueryResponse, PermissionQueryResponse } from '../../interfaces/account-permission';

@Injectable({
  providedIn: 'root',
})
export class UserPermissions extends Query<PermissionQueryResponse> {
  document = gql(`
    query permissionsByUser($userUid: ID!) {
      permissionsByUser(userUid: $userUid) {
        code
        success
        message
        permissions {
          uid
          accountUid
          accountTitle
          title
          access_type
          description
          permission
        }
      }
    }`);
}

@Injectable({
  providedIn: 'root',
})
export class Permissions extends Query<AccountPermissionQueryResponse> {
  document = gql(`
    query permissions($where: ModelPermissionFilterInput, $limit: Int, $offset: Int) {
      permissions (where: $where, limit: $limit, offset: $offset) {
        code
        success
        message
        permissions {
          uid
          accountUid
          count
          title
          access_type
          description
          permission
        }
      }
    }`);
}

@Injectable({
  providedIn: 'root',
})
// Returns all active permissions and permission options for a user
export class PermissionsAndOptionsByUser extends Query {
  document = gql(`
  query permissionsAndOptionsByUser($userUid: ID! $adminUid: ID) {
    permissionsAndOptionsByUser(userUid: $userUid, adminUid: $adminUid) {
      code
      permissions {
        uid
        accountUid
        title
        permission
      }
      options {
        accountUid
        accountTitle
        permissionUid
        permissionTitle
        enabled
        options {
          title
          uid
        }
      }
    }
}`);
}

@Injectable({
  providedIn: 'root',
})
// Returns a single permission via it's uid
export class PermissionQuery extends Query {
  document = gql(`
  query permission($uid: ID!) {
    permission(uid: $uid) {
      code
      success
      message
      permission {
        uid
        accountUid
        title
        access_type
        description
        permission
      }
    }
}`);
}

@Injectable({
  providedIn: 'root',
})
// Returns if user is authorized to view a report
export class ReportViewerAuthQuery extends Query {
  document = gql(`
  query reportViewAuth($userUid: String!, $accountUid: String!) {
    reportViewAuth(userUid: $userUid, accountUid: $accountUid) {
      code
      success
      message
      auth
    }
}`);
}
